import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {toast} from "react-toastify";
import axios from "axios";
import {Col, Row, Spinner} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import {
    setDrugReportRequestData,
    setDrugReportResponseData
} from "../../../../_reducers/DataPanel/Prescription/prescriptionSlice";
import DateHelper from "../../../primer/DateHelper/DateHelper";
import DateBox from "../../../primer/DateBox";
import {getGreekCurrencyFormat, isEmpty} from "../../../../_helpers/commonFunctions";
import moment from "moment/moment";
import BootstrapDropdown from "react-bootstrap/Dropdown";
import {jsPDF} from "jspdf";
import {autoTable} from "jspdf-autotable";
import {liberationSerif} from "../../../../fonts/liberationSerif";
import {dejavuSans} from "../../../../fonts/DejaVuSans-normal";
import {dejavuSansBold} from "../../../../fonts/DejaVuSans-Bold-bold";
import * as XLSX from "xlsx";
import Dropdown from "../../../primer/Dropdown";

const ReportsDrugs = () => {
    const dispatch = useDispatch();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const requestData = useSelector((state) => state.PRESCRIPTION.drugReportRequestData);
    const responseData = useSelector((state) => state.PRESCRIPTION.drugReportResponseData);

    const [loading, setLoading] = useState(false);

    const dateTypes = [
        {value: "startDate", label: "Ημερομηνία συνταγογράφησης"},
        {value: "executionDate", label: "Ημερομηνία εκτέλεσης"},
        {value: "endDate", label: "Ημερομηνία λήξης"}
    ]

    const fetchReport = () => {
        if (isEmpty(requestData.date_from) || isEmpty(requestData.date_to)) return toast.error("Παρακαλώ συμπληρώστε ημερομηνία από και έως.");

        setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/prescription/reports-drugs`, {
            ...requestData,
            company: company.id,
        }, {
            headers: { 'Content-Type': 'application/json' },
        }).then((res) => {
            if (res.data.status === "200") {
                dispatch(setDrugReportResponseData({...responseData, data: res.data.data}));
                toast.success("Τα δεδομένα ανανεώθηκαν", {autoClose: 1000});
            } else {
                toast.error(res.data.message);
            }
            setLoading(false);
        }).catch((err) => {
            setLoading(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const handleOnChange = (e, type, name) => {
        let prepChange = {};
        if (type === "db") {
            if (moment(e).isValid()) {
                prepChange[name] = moment(e).format("DD/MM/YYYY");
            } else {
                prepChange[name] = "";
            }
        } else if (type === "dd") {
            prepChange[name] = e.value;
        }
        dispatch(setDrugReportRequestData({...requestData, ...prepChange}));
    }

    const getTotal = (arr, key, digits = 0) => {
        let total = 0;
        for (let d of arr) {
            if (d[key]) {
                let val = +d[key] || 0;
                total += val;
            }
        }
        return +Number(total).toFixed(digits);
    }

    const handlePDFExport = () => {
        let rows = [];
        const headerColumns = ["Barcode φαρμάκου", "Όνομα φαρμάκου", "Κύρια δραστική ουσία", "Συντ/νη ποσότητα", "Συντ/νη αξία"]
        for (let d of responseData.data) {
            rows.push([
                d.barcode,
                d.erp_displayName,
                d.erp_main_active_substance,
                d.erp_drugAmount,
                getGreekCurrencyFormat(d.erp_totalPrice),
            ])
        }
        rows.push([
            {content: `Σύνολα`, colSpan: 3, styles: {halign: "center", fillColor: "#decae3"}},
            {content: getTotal(responseData.data, "erp_drugAmount", 0), styles: {halign: "center", fillColor: "#decae3"}},
            {content: getGreekCurrencyFormat(getTotal(responseData.data, "erp_totalPrice", 2)), styles: {halign: "center", fillColor: "#decae3"}},
        ])
        const doc = new jsPDF('landscape');
        let y = 20;
        doc.addFileToVFS("arialuni.ttf", liberationSerif);
        doc.addFont("arialuni.ttf", "Arial Unicode MS", "normal");
        doc.addFileToVFS("dejavusans.ttf", dejavuSans);
        doc.addFont("dejavusans.ttf", "DejaVu Sans Normal", "normal");
        doc.addFileToVFS("dejavusansBold.ttf", dejavuSansBold);
        doc.addFont("dejavusansBold.ttf", "DejaVu Sans Bold", "normal");
        doc.setFont("DejaVu Sans Bold");
        doc.setFontSize(10);
        const header = doc.splitTextToSize(`Συνταγογραφημένα Φάρμακα`, 200);
        const headerString = header.join("\n");
        doc.text(headerString, doc.internal.pageSize.getWidth() / 4, 9, {alignment: "center"});
        doc.setFont("DejaVu Sans Normal");
        const imgData = 'assets/images/prrimer-logo.png';
        const imgX = doc.internal.pageSize.getWidth() - 45; // adjust the position as needed
        const imgY = 3; // adjust the position as needed
        doc.addImage(imgData, 'PNG', imgX, imgY, 40, 15);
        doc.setFont("DejaVu Sans Normal");
        autoTable(doc, {
            startY: y,
            head: [headerColumns],
            body: rows,
            rowPageBreak: "avoid",
            styles: {
                font: "DejaVu Sans Normal",
                fontStyle: "normal",
                fontSize: 8, // set font size
                halign: "center", // set alignment
            },
        })
        const pageCount = doc.getNumberOfPages();
        // Add the pagination to each page
        for (let i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            doc.setFontSize(10);
            doc.text(`Σελίδα ${i} από ${pageCount}`, 10, doc.internal.pageSize.getHeight() - 10);
        }
        doc.save(`Συνταγογραφημένα Φάρμακα.pdf`);
    }

    const handleExcelExport = () => {
        let rows = [];
        const dateExported = moment().format("DD/MM/YYYY HH:mm:ss");
        if (!isEmpty(requestData.date_from) && !isEmpty(requestData.date_to)) rows.push([`Εύρος ημερομηνίας: ${requestData.date_from} - ${requestData.date_to}`]);
        rows.push(["Επωνυμία:", company.name]);
        rows.push(["ΑΦΜ:", company.vatNumber]);
        rows.push([`Ημερομηνία Εξαγωγής: ${dateExported}`]);
        rows.push([]);
        rows.push(["Barcode φαρμάκου", "Όνομα φαρμάκου", "Κύρια δραστική ουσία", "Συντ/νη ποσότητα", "Συντ/νη αξία"]);
        for (let d of responseData.data) {
            rows.push([
                d.barcode,
                d.erp_displayName,
                d.erp_main_active_substance,
                d.erp_drugAmount,
                d.erp_totalPrice,
            ])
        }
        rows.push([
            "",
            "",
            `Σύνολα`,
            getTotal(responseData.data, "erp_drugAmount", 0),
            getTotal(responseData.data, "erp_totalPrice", 2),
        ])
        const workSheet = XLSX.utils.aoa_to_sheet(rows);
        const workBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workBook, workSheet, "Φάρμακα");
        XLSX.writeFile(workBook, 'Συνταγογραφημένα Φάρμακα.xlsx');
    }

    return (
        <React.Fragment>
            <Row>
                <Col md={3}>
                    <Dropdown
                        name={"dateType"}
                        label={"Τύπος ημερομηνίας"}
                        options={dateTypes}
                        defaultValue={dateTypes.find((el) => el.value === requestData.dateType)}
                        key={Math.random()}
                        onChange={(e) => handleOnChange(e, "dd", "dateType")}
                    />
                </Col>
                <Col md={2}>
                    <DateHelper
                        dateFromAndToFunction={(from, to) => dispatch(setDrugReportRequestData({...requestData, date_from: from, date_to: to}))}
                    />
                </Col>
                <Col md={2}>
                    <DateBox
                        name="date_from"
                        selected={moment(requestData.date_from, "DD/MM/YYYY").isValid() ? moment(requestData.date_from, "DD/MM/YYYY").toDate() : ""}
                        label={"Ημερομηνία από"}
                        allowOtherYears={true}
                        onChange={(e) => handleOnChange(e, "db", "date_from")}
                    />
                </Col>
                <Col md={2}>
                    <DateBox
                        name="date_to"
                        selected={moment(requestData.date_to, "DD/MM/YYYY").isValid() ? moment(requestData.date_to, "DD/MM/YYYY").toDate() : ""}
                        label={"Ημερομηνία έως"}
                        allowOtherYears={true}
                        onChange={(e) => handleOnChange(e, "db", "date_to")}
                    />
                </Col>
                <Col md={3}>
                    <Button style={{marginTop: "20px"}} disabled={loading} onClick={() => fetchReport()}>
                        Εφαρμογή φίλτρων {loading && <Spinner className={"ml-2"} animation={"border"} variant={"dark"}/>}
                    </Button>
                </Col>
            </Row>
            {responseData.data?.length > 0 && (
                <React.Fragment>
                    <table className={"simpleClassicTable mt-2"}>
                        <colgroup>
                            <col span={1} style={{width: "15%"}}></col>
                            <col span={1} style={{width: "35%"}}></col>
                            <col span={1} style={{width: "30%"}}></col>
                            <col span={1} style={{width: "10%"}}></col>
                            <col span={1} style={{width: "10%"}}></col>
                        </colgroup>
                        <thead>
                        <tr>
                            <th>Barcode φαρμάκου</th>
                            <th>Όνομα φαρμάκου</th>
                            <th>Κύρια δραστική ουσία</th>
                            <th>Συνταγογραφημένη ποσότητα</th>
                            <th>Συνταγογραφημένη αξία</th>
                        </tr>
                        </thead>
                        <tbody>
                        {responseData.data.map((drug, idx) => (
                            <React.Fragment>
                                <tr key={`drugReport-${idx}`}>
                                    <td>{drug.barcode}</td>
                                    <td>{drug.erp_displayName}</td>
                                    <td>{drug.erp_main_active_substance}</td>
                                    <td>{drug.erp_drugAmount}</td>
                                    <td>{getGreekCurrencyFormat(drug.erp_totalPrice)}</td>
                                </tr>
                            </React.Fragment>
                        ))}
                        <tr style={{fontWeight: "700", backgroundColor: "#decae3"}}>
                            <td colSpan={3}>Σύνολα</td>
                            <td>{getTotal(responseData.data, "erp_drugAmount", 0)}</td>
                            <td>{getGreekCurrencyFormat(getTotal(responseData.data, "erp_totalPrice", 2))}</td>
                        </tr>
                        </tbody>
                    </table>

                    <Row>
                        <BootstrapDropdown className="mb-3 mt-3">
                            <BootstrapDropdown.Toggle variant="primary" id="dropdown-basic">
                                Αποθήκευση αποτελεσμάτων
                            </BootstrapDropdown.Toggle>
                            <BootstrapDropdown.Menu>
                                <BootstrapDropdown.Item onClick={() => handlePDFExport()}>
                                    Αποθήκευση ως PDF
                                </BootstrapDropdown.Item>
                                <BootstrapDropdown.Item onClick={() => handleExcelExport()}>
                                    Αποθήκευση ως XLSX
                                </BootstrapDropdown.Item>
                            </BootstrapDropdown.Menu>
                        </BootstrapDropdown>
                    </Row>
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export default ReportsDrugs
